import { Avatar } from '@mui/material';
import React from 'react';
import { BiPhone } from 'react-icons/bi';
import {} from 'react-icons/bs';
import { FaWhatsapp } from 'react-icons/fa6';
import { MdEmail } from 'react-icons/md';
import { AccountManagerForCompany, UserDocument } from 'types';

interface Props {
	accountManagers: AccountManagerForCompany[];
}

const AccountManagers = ({ accountManagers }: Props) => {
	// const accountManagers = [
	// 	{
	// 		profileUrl: 'https://picsum.photos/id/237/200/300',
	// 		name: 'Andrea Watkins',
	// 		mobile: '+91-9768452322',
	// 		email: 'andrea.watkins@masaischool.com',
	// 	},
	// 	{
	// 		profileUrl: 'https://picsum.photos/seed/picsum/200/300',
	// 		name: 'Dummy Manager',
	// 		mobile: '+91-9768452322',
	// 		email: 'andrea.watkins@masaischool.com',
	// 	},
	// ];
	// console.log(accountManagers);
	return (
		<div className="p-[16px] grid gap-[16px]">
			{accountManagers.map((manager, i) => {
				const accountManager = manager.accountManager as UserDocument;
				return (
					<div key={i} className="flex gap-[12px] ">
						<Avatar
							className="w-[48px] h-[48px] rounded-[50%]"
							src={accountManager.profile.imageUrl || accountManager.profile.profileImageUrl || accountManager.profile.profileImageUrl || ''}
							alt={accountManager.name}
						>
							{accountManager.name[0]}
						</Avatar>
						{/* <Img
							className="w-[48px] h-[48px] rounded-[50%]"
							src={accountManager.profile.imageUrl || accountManager.profile.profileImageUrl || ''}
							alt={accountManager.name}
						/> */}

						<div className="grid gap-[4px]">
							<p className="font-inter text-[18px] font-[600] leading-[28px] text-[#1C1C28]">{accountManager.name}</p>
							<div className="grid gap-[2px]">
								<div className="flex gap-[4px]">
									<div
										className="flex gap-[4px] cursor-pointer"
										onClick={() => {
											window.open(`tel:${accountManager.phone}`, '_blank');
										}}
									>
										<BiPhone color="#00B7C4" className="cursor-pointer" />
										<p className="font-inter text-[12px] font-[500] leading-[16px] text-[#555770]">
											{accountManager.phone}
										</p>
									</div>
									<FaWhatsapp
										onClick={() => {
											window.open(`https://wa.me/${accountManager.phone}`, '_blank');
										}}
										color="#23B33A"
										className="cursor-pointer"
									/>
								</div>
								<div
									className="flex gap-[4px] cursor-pointer"
									onClick={() => {
										window.open(`mailto:${accountManager.email}`, '_blank');
									}}
								>
									<MdEmail color="#00B7C4" />
									<p className="font-inter text-[12px] font-[500] leading-[16px] text-[#555770]">
										{accountManager.email}
									</p>
								</div>
							</div>
						</div>
					</div>
				);
			})}
		</div>
	);
};

export default AccountManagers;
